import { ZONE } from 'src/app/const';

export const isZone = (value: string): boolean => !!Object.keys(ZONE).find((key) => ZONE[key as keyof typeof ZONE] === value);
